<div class="job-detail-container" data-cy="locumsJobDetailsPage">
    <nova-detail-toolbar [title]="'Job Details - ' + title" [showBackButton]="showBackButton" [template]="toolbarTemplate"></nova-detail-toolbar>

    <div class="app-job-details-header-note-container" *ngIf="isOnHold">
        <div class="app-dialog-note-container app-first-note-container">
            <div class="app-dialog-note-table">
                <div class="app-dialog-note-row">
                    <div class="app-dialog-note-cell app-width-36px">
                        <div class="app-dialog-note-icon">
                            <img src="assets/images/big_stop_sign.png"
                                 class="rating-img"
                                 title="Job on Hold"
                                 alt="job on hold" />
                        </div>
                    </div>
                    <div class="app-dialog-note-cell app-v-center">
                        <span class="app-dialog-note-text">This job is on hold (not accepting submittals)</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="main-container">
        <div>
            <ul id="sectionLinks">
                <li><a id="ratesLink" class="active" (click)="scrollIntoView('#rates')">Rates</a></li>
                <li><a id="scheduleLink" (click)="scrollIntoView('#schedule')">Schedule</a></li>
                <li><a id="facilityLink" (click)="scrollIntoView('#facility')">Facility</a></li>
                <li><a id="workLink" (click)="scrollIntoView('#work')">Work</a></li>
                <li><a id="requirementsLink" (click)="scrollIntoView('#requirements')">Requirements</a></li>
                <li><a id="generalLink" (click)="scrollIntoView('#general')">General</a></li>
            </ul>
        </div>
        <div class="card" id="sections">
            <h3 id="rates">Rates</h3>
            <nova-locums-recruiter-rates [displayConfigData]="displayConfigData"></nova-locums-recruiter-rates>
            <div class="divider"></div>

            <h3 id="schedule">Schedule</h3>
            <nova-locums-recruiter-schedule [displayConfigData]="displayConfigData"></nova-locums-recruiter-schedule>
            <div class="divider"></div>

            <h3 id="facility">Facility</h3>
            <nova-locums-recruiter-facility [jobId]="id" [displayConfigData]="displayConfigData"></nova-locums-recruiter-facility>
            <div class="divider"></div>
            <h3 id="work">Work</h3>
            <nova-locums-recruiter-work [jobId]="id"></nova-locums-recruiter-work>
            <div class="divider"></div>

            <h3 id="requirements">Requirements</h3>
            <nova-locums-recruiter-requirements [jobId]="id"></nova-locums-recruiter-requirements>
            <div class="divider"></div>

            <h3 id="general">General</h3>
            <nova-locums-recruiter-general></nova-locums-recruiter-general>
        </div>
        <div class="column">
            <div class="card">
                <nova-locums-recruiter-add-details [displayConfigData]="displayConfigData"></nova-locums-recruiter-add-details>
            </div>
            <div class="card">
                <nova-locums-recruiter-submittal-info></nova-locums-recruiter-submittal-info>
            </div>
        </div>
    </div>

    <ng-template #toolbarTemplate>
        <div class="toolbar-template">
            @if (employmentTypeCode === EmploymentTypeCode.LocumTenens1099 && isLocums1099MarginCalculatorEnabled()) {
            <button mat-flat-button
                    dataQaId="locums_1099_create_margin_button"
                    class="toolbar-button"
                    (click)="openCandidateSearchDialog()">               
                CREATE MARGIN
            </button>
            }
        </div>
    </ng-template>
</div>
